import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) { }

  success(title: string | undefined, msg: string | undefined) {
    this.toastr.success(msg, title);
  }
  successHtml(title: string | undefined, msg: string | undefined) {
    this.toastr.success(msg, title, { enableHtml: true });
  }
  info(title: string | undefined, msg: string | undefined) {
    this.toastr.info(msg, title);
  }
  warning(title: string | undefined, msg: string | undefined) {
    this.toastr.warning(msg, title);
  }
  error(title: string | undefined, msg: string | undefined) {
    this.toastr.error(msg, title);
  }

  wait(title: string | undefined, msg: string | undefined) {
    this.toastr.info(msg, title, { timeOut: 3000 });
  }
}
